import axios from 'axios';
import router from '../router';

export const axiosClient = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

axiosClient.interceptors.request.use((config) => {
  config.headers["Access-Control-Allow-Origin"] = "*";
  if (config.headers !== undefined) {
    const accessToken = localStorage.getItem('api_token');

    if (accessToken !== null) {
      config.headers["x-pataka-token"] = accessToken;
    }
  }
  return config;
});

// レスポンスインターセプターを追加
axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // /loginパスへのリクエストの場合は401エラーハンドリングをスキップ
    if (error.response && error.response.status === 401 && !error.config.url.includes('/login')) {
      // トークンを削除
      localStorage.removeItem('api_token');
      // ログイン画面へリダイレクト
      router.push('/login');
    }
    return Promise.reject(error);
  }
);
